(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function track(name, props) {
    try {
      if (typeof window.msTrack === 'function') window.msTrack(name, props || {});
    } catch (e) {}
  }

  ready(function () {
    var root = document.querySelector('[data-ms-cart]');
    if (!root) return;

    var form = root.querySelector('[data-ms-cart-form]');
    if (!form) {
      track('cart_viewed', { empty: true, item_count: 0 });
      return;
    }

    track('cart_viewed', {
      empty: false,
      item_count: root.querySelectorAll('[data-ms-line]').length
    });

    function setUpdating(on) {
      root.classList.toggle('is-updating', !!on);
      form.querySelectorAll('button[type="submit"]').forEach(function (btn) {
        btn.disabled = !!on;
      });
    }

    function changeLine(line, quantity) {
      setUpdating(true);
      track('cart_quantity_changed', { line: line, quantity: quantity });

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Cart update failed');
          return r.json();
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          setUpdating(false);
          track('cart_quantity_failed', { line: line, quantity: quantity });
        });
    }

    root.querySelectorAll('[data-ms-line]').forEach(function (lineEl) {
      var input = lineEl.querySelector('[data-ms-qty-input]');
      var minus = lineEl.querySelector('[data-ms-qty-minus]');
      var plus = lineEl.querySelector('[data-ms-qty-plus]');
      var remove = lineEl.querySelector('[data-ms-remove]');
      if (!input) return;

      var line = Number(input.getAttribute('data-line')) || 1;

      if (minus) {
        minus.addEventListener('click', function () {
          var next = Math.max(0, (Number(input.value) || 1) - 1);
          changeLine(line, next);
        });
      }

      if (plus) {
        plus.addEventListener('click', function () {
          var next = (Number(input.value) || 1) + 1;
          changeLine(line, next);
        });
      }

      if (remove) {
        remove.addEventListener('click', function () {
          track('cart_item_removed', { line: line });
          changeLine(line, 0);
        });
      }

      input.addEventListener('change', function () {
        var next = Math.max(0, Number(input.value) || 0);
        changeLine(line, next);
      });
    });

    form.addEventListener('submit', function () {
      track('cart_checkout_clicked', {
        item_count: root.querySelectorAll('[data-ms-line]').length
      });
    });
  });
})();
